import { Routes } from '@angular/router';

import { CAN_ACTIVATE_AUTH_GUARD } from '@auth/guards/can-activate.auth.guard';
import {
  SYSTEM_ADMIN_ONLY_CAN_ACTIVATE_GUARD,
  SYSTEM_ADMIN_ONLY_CAN_MATCH_GUARD
} from '@core/guards/system-admin-only.guard';
import { ErrorComponent } from '@shared/components/error/error.component';
import { PageNotFoundComponent } from '@shared/components/page-not-found/page-not-found.component';
import { StyleGuideComponent } from '@shared/components/style-guide/style-guide.component';

export const APP_ROUTES: Routes = [
  {
    path: 'clients',
    loadChildren: () =>
      import('@clients/clients.routes').then(m => m.CLIENTS_ROUTES),
    canActivate: [CAN_ACTIVATE_AUTH_GUARD],
    data: {
      title: 'Clients'
    }
  },
  {
    path: 'system-admins',
    loadChildren: () =>
      import('@system-admins/system-admins.routes').then(
        m => m.SYSTEM_ADMINS_ROUTES
      ),
    canActivate: [
      CAN_ACTIVATE_AUTH_GUARD,
      SYSTEM_ADMIN_ONLY_CAN_ACTIVATE_GUARD
    ],
    canMatch: [SYSTEM_ADMIN_ONLY_CAN_MATCH_GUARD],
    data: {
      title: 'Admins'
    }
  },
  {
    path: 'sso',
    loadChildren: () =>
      import('@federations/federations.routes').then(m => m.FEDERATIONS_ROUTES),
    canActivate: [
      CAN_ACTIVATE_AUTH_GUARD,
      SYSTEM_ADMIN_ONLY_CAN_ACTIVATE_GUARD
    ],
    canMatch: [SYSTEM_ADMIN_ONLY_CAN_MATCH_GUARD],
    data: {
      title: 'SSO'
    }
  },
  {
    path: 'my-profile',
    loadChildren: () =>
      import('@my-profile/my-profile.routes').then(m => m.MY_PROFILE_ROUTES),
    canActivate: [CAN_ACTIVATE_AUTH_GUARD],
    data: {
      title: 'My Account'
    }
  },
  {
    path: 'error',
    component: ErrorComponent,
    pathMatch: 'full',
    data: {
      title: 'Error'
    }
  },
  {
    path: 'style-guide',
    component: StyleGuideComponent,
    pathMatch: 'full'
  },
  { path: '', pathMatch: 'full', redirectTo: 'clients' },
  { path: '**', component: PageNotFoundComponent }
];
